import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Ignorar localhost OU qualquer porta definida
const isLocal = window.location.hostname === "localhost" || window.location.port !== "";

if (!isLocal) {
  ReactGA.initialize("G-L2DKLML7PZ");
}

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isLocal) {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location.pathname]);

  return null;
}

export function logEvent(eventName: string, params?: object) {
  if (!isLocal) {
    ReactGA.event(eventName, params);
  }
}
